import React from 'react';
import { compose } from 'redux';
import { MediaSourceType } from '../../types';
import { PapiGallection } from '@wix/da-papi-types';
import { setGallectionCover, SetGallectionCoverPayload } from '../../actions';
import MediaSelector from '../../MediaSelector';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { useCurrentMediaSource } from '../../_hocs/withCurrentMediaSource';
import { useGruser } from '../../_hocs/withGruser';
import { DEVIATION_TYPES_ALLOWED_AS_FOLDER_COVER } from '../../constants';

export interface Props {
  gallection: PapiGallection;
  onClose: () => void;
}

type MediaStoreDispatchProps = {
  setGallectionCover: (payload: SetGallectionCoverPayload) => void;
};

const enhance = compose(
  connectMediaStore<{}, MediaStoreDispatchProps, Props, {}>(null, {
    setGallectionCover,
  })
);

export const GallectionCoverSelector: React.FC<
  Props & MediaStoreDispatchProps
> = ({ gallection, setGallectionCover: setGallectionCoverAction, onClose }) => {
  const { currentMediaSource } = useCurrentMediaSource();
  const { gruser } = useGruser();
  return (
    <MediaSelector
      initialMediaSource={currentMediaSource!}
      gruser={gruser}
      mediaSourceTypes={[currentMediaSource!, MediaSourceType.STASH]}
      allowGifs={false}
      allowedDeviationTypes={DEVIATION_TYPES_ALLOWED_AS_FOLDER_COVER}
      onClose={onClose}
      onSelect={selectedDeviations => {
        setGallectionCoverAction({
          gallection,
          deviation: selectedDeviations[0],
        });
        onClose();
      }}
    />
  );
};
GallectionCoverSelector.displayName = 'GallectionCoverSelector';

export default enhance(
  GallectionCoverSelector
) as any as React.ComponentType<Props>;
